<template>
  <div class="nav-bar">
    <div class="logo">
      <img src="https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/tp_logo_white.png" alt="" />
    </div>
    <div class="title">整体解决方案场景VR演示</div>
    <div class="nav-right">
      <div class="nav-right-item" @click="setAutoRotate">自动旋转</div>
      <div class="nav-right-item"><span @click="zoomOut">缩小</span> <span class="line"></span> <span @click="zoomIn">放大</span></div>
      <div class="nav-right-item" @click="reset">重置</div>
      <div class="nav-right-item" @click="fullscreen">全屏</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navBar',
  props: {
    id: Number,
  },
  data() {
    return {
      isTwoLine: false
    }
  },
  computed: {

  },
  mounted() {

  },
  updated() {

  },
  methods: {
    setAutoRotate() {
      this.$emit('autorotate')
    },
    zoomIn() {
      this.$emit('zoomin')
    },
    zoomOut() {
      this.$emit('zoomout')
    },
    reset() {
      this.$emit('reset')
    },
    fullscreen() {
      const elem = document.documentElement; // You can replace this with a specific element if needed

      if (!document.fullscreenElement) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }

    }
  },
  created() {
    //console.log(this.id)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "sass:math";

@function px2vw($px) {
  @return math.div(100px * $px, 1920px) * 1vw;
}

@font-face {
  font-family: 'SourceHanSansCN-Medium';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Medium.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Medium.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Medium.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Medium.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Medium.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SourceHanSansCN-Regular';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SourceHanSansCN-Bold';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

.nav-bar {
  z-index: 50;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: px2vw(60);
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.00) 100%);
}

.logo {
  width: px2vw(122);
  height: px2vw(14);
  display: block;
  position: fixed;
  top: px2vw(23);
  left: px2vw(60);
  border-right: px2vw(1) solid #fff;

  img {
    height: 100%;
    display: block;
  }
}

.title {
  font-family: SourceHanSansCN-Medium;
  font-size: px2vw(16);
  color: #FFFFFF;
  letter-spacing: px2vw(0.32);
  position: fixed;
  top: px2vw(22);
  left: px2vw(195);
  line-height: px2vw(14);
  font-weight: 400;
}

.nav-right {
  width: px2vw(80);
  position: fixed;
  height: px2vw(168);
  right: 0;
  top: px2vw(80);

  .nav-right-item {
    width: px2vw(80);
    height: px2vw(32);
    font-family: SourceHanSansCN-Bold;
    font-size: px2vw(12);
    color: #FFF;
    letter-spacing: px2vw(0.24);
    line-height: px2vw(32);
    margin-bottom: px2vw(10);
    background: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;


    .line{
        height: px2vw(13);
        width: 1px;
        background: #fff;
        margin: 0 px2vw(6);
    }

    &:hover {
      color: #FFDA2D;

      span {
        color: #fff;
        

        &:hover {
          color: #FFDA2D;
        }
      }
    }
  }
}
</style>
